module.exports = __webpack_public_path__ + "assets/img/workLeft4.6bf8a548.png";